import {RESET_SEARCH, SET_SEARCH_RESULT_SUCCESS, SET_RESOURCE_PDF_URL, RESET_RESOURCE_PDF_URL, SET_PDF_URL_LOADER, RESET_PDF_URL_LOADER } from '../_actions/search.actions';

export const INITIAL_STATE = {printSections:[], loadMore: false, searchResults: [], activeResourcePDFURL: '', isPDFURLLoading: ''};
export function resourceSearchReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_SEARCH_RESULT_SUCCESS: {
            return ({
                ...state,
                searchResults: action.payload
            });
        }
        case SET_RESOURCE_PDF_URL : {
            return ({
                ...state,
                activeResourcePDFURL: action.payload
            });
        }
        case RESET_RESOURCE_PDF_URL: {
            return ({
                ...state,
                activeResourcePDFURL: INITIAL_STATE.activeResourcePDFURL
            });
        }
        case RESET_SEARCH: {
            return INITIAL_STATE;
        }
        case SET_PDF_URL_LOADER : {
            return ({
                ...state,
                isPDFURLLoading: action.payload
            });
        }
        case RESET_PDF_URL_LOADER: {
            return ({
                ...state,
                isPDFURLLoading: action.payload
            });
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/resource.search.reducer.js